// ##ChangeObservable:
// This allows subscribing to a value outside of React/Redux and the old
// computation model.
export interface ChangeObservable<T> {
    readonly current: T;

    subscribe(onChange: (newVal: T) => void): void;
    unsubscribe(onChange: (newVal: T) => void): void;
}

export class Watchable<T> implements ChangeObservable<T> {
    private subscribers: Set<(val: T) => void> = new Set();

    constructor(private val: T) {}

    public get current(): T {
        return this.val;
    }
    public set current(newVal: T) {
        this.val = newVal;
        this.subscribers.forEach(cb => cb(newVal));
    }

    public subscribe(onChange: (newVal: T) => void): void {
        this.subscribers.add(onChange);
    }

    public unsubscribe(onChange: (newVal: T) => void) {
        this.subscribers.delete(onChange);
    }
}
